<template>
  <v-expansion-panel popout expand v-model="settingsPanel">

    <!-- Cinema Settings section -->
    <v-expansion-panel-content>
      <div slot="header"><span class="headline">Cinema Settings</span></div>
      <v-card>
        <v-card-text>
          <c-business-rules></c-business-rules>
        </v-card-text>
      </v-card>
    </v-expansion-panel-content>

  </v-expansion-panel>
</template>

<script>
  import {mapActions} from 'vuex';

  export default {
    name: "Settings",

    data () {
      return {
        settingsPanel: [ true ]
      }
    },

    created() {
      this.setActiveMenu('Settings');
      this.setActiveSubmenu('Business Rules');
    },

    methods: {
      ...mapActions([
        'setActiveMenu',
        'setActiveSubmenu'
      ])
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/settings/Settings.vue